import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela
} from '../veiculoAlerta/veiculoAlertaActions';

class VeiculoAlertaForm extends Component {

	state = {
		modoCadastroLocal: false,
		local: null,
		modoCadastroVeiculo: false,
		veiculo: null
	}

    componentWillMount() {
    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='datahora_previsao'
								component={LabelAndInputDateTime}
								label='Date e Hora Previsão' placeholder='Informe a data'
								cols='12 12 4 3'
								readOnly={readOnly} />
						</Row>

						<Row>
							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição' placeholder='Informe a descrição'
								cols='12 12 12 12'
								readOnly={readOnly} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

VeiculoAlertaForm = reduxForm({form: 'veiculoAlertaForm', destroyOnUnmount: false})(VeiculoAlertaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('veiculoAlertaForm')(state),
	registro: state.veiculoAlerta.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VeiculoAlertaForm);
